import React from "react";
import { BsGithub, BsLinkedin, BsFacebook } from "react-icons/bs";

const Footer = () => {
    return (
        <div className="my-16" id="footer">
            <div className="flex flex-col md:flex-row justify-between items-center">
                <div className="flex flex-col text-center md:text-left">
                    <p className="text-light">Designed by Ryan Warner and developed by Ashraful Hassan.</p>
                    <p className="text-light">
                        Built with <strong className="text-white">React</strong> and hosted on{" "}
                        <strong className="text-white">Apache server.</strong>
                    </p>
                </div>
                <div className="flex flex-row mt-6">
                    <a href="https://github.com/Ashraf-Raneem" target="_blank" rel="noreferrer">
                        <BsGithub color="#ffffff" size="1.50rem" className="mx-2" />
                    </a>
                    <a href="https://www.linkedin.com/in/ashraf-raneem-2b94361a0/" target="_blank" rel="noreferrer">
                        <BsLinkedin color="#ffffff" size="1.50rem" className="mx-2" />
                    </a>
                    <a href="https://www.facebook.com/ashraf.raneem" target="_blank" rel="noreferrer">
                        <BsFacebook color="#ffffff" size="1.50rem" className="mx-2" />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Footer;
